<script lang="ts">
	/**
	 * Whether the component is in an active state.
	 * - When `true`, the dot will have a darker background color.
	 * - When `false`, the dot will have a lighter background color.
	 * @type {boolean}
	 * @default false
	 */
	export let active: boolean = false;
</script>

<button
	aria-label="mobile step"
	on:click
	class="h-2.5 w-2.5 rounded-full {$$props.class}
    {active ? 'bg-gray-400' : 'bg-gray-200'}
"
></button>
